<div class="audio-container">
  <span class="audio-player-controls">
    <button mat-icon-button (click)="onPreviousClick()" type="button">
      <mat-icon>skip_previous</mat-icon>
    </button>
    <audio controls #audioElement [src]="src | fileUrl">
      <p>Your browser does not support HTML5 audio. Here is a <a [href]="src | fileUrl">link</a> instead.</p>
    </audio>
    <button mat-icon-button (click)="onNextClick()" type="button">
      <mat-icon>skip_next</mat-icon>
    </button>
  </span>
  @if (showError) {
    <p class="error-msg">Failed to load audio file</p>
  }
</div>
